import React from "react";
import { Link } from "react-router-dom";
import "./AboutBreadcrumb.css";

const AboutBreadcrumb = ({ label = "Get To Know Us" }) => {
  const bgImage = "/assets/images/Abouthero.webp"; // public path

  return (
    <section
      className="about-breadcrumb"
      style={{
        background: `url(${bgImage}) center/cover no-repeat`,
      }}
    >
      <div className="breadcrumb-overlay">
        <h2 className="breadcrumb-title">
          <Link to="/" className="breadcrumb-link">
            Home
          </Link>
          <span> / {label}</span>
        </h2>
      </div>
    </section>
  );
};

export default AboutBreadcrumb;
